/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetContractsPublicRegionIdNotFound
 */
export interface GetContractsPublicRegionIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetContractsPublicRegionIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetContractsPublicRegionIdNotFound interface.
 */
export function instanceOfGetContractsPublicRegionIdNotFound(value: object): value is GetContractsPublicRegionIdNotFound {
    return true;
}

export function GetContractsPublicRegionIdNotFoundFromJSON(json: any): GetContractsPublicRegionIdNotFound {
    return GetContractsPublicRegionIdNotFoundFromJSONTyped(json, false);
}

export function GetContractsPublicRegionIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContractsPublicRegionIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetContractsPublicRegionIdNotFoundToJSON(json: any): GetContractsPublicRegionIdNotFound {
    return GetContractsPublicRegionIdNotFoundToJSONTyped(json, false);
}

export function GetContractsPublicRegionIdNotFoundToJSONTyped(value?: GetContractsPublicRegionIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

